var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "copywritingExtract" }, [
    _c(
      "div",
      {
        staticClass: "title",
        on: {
          click: function ($event) {
            return _vm.openUrl(_vm.obj.linkUrl)
          },
        },
      },
      [_vm._v(" " + _vm._s(_vm.obj.title) + " ")]
    ),
    _c("div", { staticClass: "detail" }, [
      _vm._v(" 时间："),
      _c("span", { staticStyle: { "margin-right": "64px" } }, [
        _vm._v(_vm._s(_vm.obj.createdTime)),
      ]),
      _vm._v(" 热度："),
      _c("span", [_vm._v(_vm._s(_vm.obj.metrics))]),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "content-span" }, [_vm._v(_vm._s(_vm.content))]),
      _c("div", { staticClass: "bottom-op" }, [
        !_vm.isOk &&
        _vm.content != "文案提取中..." &&
        _vm.content !== "提取视频内容失败"
          ? _c("div", { staticClass: "float-bottom" }, [
              _c("img", {
                staticClass: "img-default",
                attrs: {
                  src: require("@/assets/image/aigc/scxt.png"),
                  alt: "",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "title-span title-span-reset",
                  on: { click: _vm.generate },
                },
                [_vm._v(" 生成选题 ")]
              ),
            ])
          : _vm._e(),
        _vm.isOk || _vm.content === "提取视频内容失败" ? _c("div") : _vm._e(),
        !!_vm.content &&
        _vm.content.length > 0 &&
        _vm.content != "文案提取中..."
          ? _c(
              "div",
              {
                staticClass: "float-bottom-right",
                on: { click: _vm.copyText },
              },
              [
                _c("img", {
                  staticClass: "img-default",
                  attrs: {
                    src: require("@/assets/image/aigc/copy.png"),
                    alt: "",
                  },
                }),
                _c("img", {
                  staticClass: "img-hover",
                  attrs: {
                    src: require("@/assets/image/aigc/copy-hover.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "tip" }, [_vm._v("复制")]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }